import getLocalString from "constants/Localization";
import { useToggleProposalProductGroupOptionalityMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useToggleProposalProductGroupOptionality() {
  const [mutation, { loading, error, data }] = useToggleProposalProductGroupOptionalityMutation();

  const [toggleProposalProductGroupOptionality, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "toggleProposalProductGroupOptionality",
    },
    {
      successMessage: getLocalString("proposals.toggle-proposal-product-optionality-success"),
      failureMessage: getLocalString("proposals.toggle-proposal-product-optionality-failure"),
    }
  );

  return [toggleProposalProductGroupOptionality, context] as const;
}
